import { useEffect, useState, useRef, useContext } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import ModalBase from "modals/base/ModalBase";
import style from "./ShippingInfoSelectModal.module.css"
import Radio from "components/inputs/radio/Radio";

import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "components/P";
import FixedFooter from "layouts/container/FixedFooter";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import Dummy from "components/Dummy";
import { BrowserDetectContext } from "providers/BrowserEventProvider";

const ShippingInfoSelectModal = NiceModal.create(
    (props) => {
        const { isMobile } = useContext(BrowserDetectContext);
        const { t } = useTranslation();
        const [withHeader, withFooter] = [true, false];
        const [width, height] = ["min(100%, 500px)", isMobile ? "60%" : "min(100%, 250px)"];
        const withCloseButton = true;
        const clickOutsideToClose = true;
        const title = t("selectShippingInfo");
        const buttonText = t("close");
        const modal = useRef();
        const [selectedShippingInfoId, setSelectedShippingInfoId] = useState();
        const { shippingAddress } = props;
        const { setSelectedShippingInfo } = props;
        const { setSelectAddressId } = props;
        const { selectAddressId } = props;
        const { setSelectAddress } = props;
        const [shippingInfos, setShippingInfos] = useState(shippingAddress);


        const [isAdd, setIsAdd] = useState(false); // 왜 있는지는 모르는데 일단 오류 나니까 추가


        const onShippingInfoChange = (shippingAddressId) => {
            // if (shippingAddress && shippingAddress.length > 0) {
            //     const selectedAddress = shippingAddress.find(
            //         (address) => address.id === shippingAddressId
            //     );

            //     if (selectedAddress) {
            //         setSelectedShippingInfo(selectedAddress);
            //     }
            // }
            // setSelectAddressId(shippingAddressId);
            // setSelectedShippingInfoId(shippingAddressId);
            // let value = shippingAddress;
            if (shippingInfos && shippingInfos.length > 0) {
                const selectedAddress = shippingInfos.find(
                    (address) => address.id === shippingAddressId
                );

                if (selectedAddress) {
                    setSelectedShippingInfo(selectedAddress);
                }
            }
            setSelectAddressId(shippingAddressId);
            setSelectedShippingInfoId(shippingAddressId);
            let value = shippingInfos;
            let disabled = true;
            let checked = true;
            if (props.callback) {
                props.callback(value, disabled, checked);
            }
            modal.current.close();
        }

        const handleCardClick = (shippingInfo) => {
            onShippingInfoChange(shippingInfo.id);
        };

        useEffect(() => {
            if (shippingAddress) {
                // ID 기반으로 중복 제거 및 정렬
                const uniqueAddresses = Array.from(
                    new Map(shippingAddress.map(item => [item.id, item])).values()
                ).sort((a, b) => {
                    const isDefaultA = a?.metadata?.default === true;
                    const isDefaultB = b?.metadata?.default === true;
                    if (isDefaultA && !isDefaultB) return -1;
                    if (!isDefaultA && isDefaultB) return 1;
                    return 0;
                });

                setShippingInfos(uniqueAddresses);
            }
        }, [shippingAddress]);

        // cleanup 함수는 별도의 useEffect로 분리
        useEffect(() => {
            return () => {
                if (props.onClose) {
                    props.onClose();
                }
            }
        }, []);

        const onShippingInfoClick = (shippingInfo) => {
            setSelectedShippingInfoId(shippingInfo.id);
            let value = shippingInfo;
            let disabled = true;
            let checked = true;
            if (props.callback) {
                props.callback(value, disabled, checked);
            }
        }

        const onAddShippingInfoClick = () => {
            isMobile ? (
              NiceModal.show("shippingInfoAddKrModal", {
                mode: "add",
                callback: onEditModalClose,
                setAdd: setIsAdd,
                onClose: onShippingInfoModalClose
              })
            )
              :
        
              NiceModal.show("shippingInfoAddModal", {
                callback: onEditModalClose,
                setIsAdd: setIsAdd,
                onClose: onShippingInfoModalClose
              })
          };

        const onEditButtonClick = (e, shippingInfo) => {
            e.stopPropagation();
            isMobile ?
                NiceModal.show("shippingInfoAddKrModal", {
                    mode: "edit",
                    data: shippingInfo,
                    callback: onEditModalClose,
                    onClose: onShippingInfoModalClose,
                }) :
                NiceModal.show("shippingInfoEditModal", {
                    data: shippingInfo,
                    callback: onEditModalClose,
                    setIsAdd: setIsAdd,
                    onClose: onShippingInfoModalClose
                });
        };
        const onShippingInfoModalClose = () => {
            return
        }

        const onEditModalClose = (value) => {
            if (value?.customer?.shipping_addresses) {
                const newAddresses = value.customer.shipping_addresses;

                // ID 기반으로 중복 제거 및 정렬
                const uniqueAddresses = Array.from(
                    new Map(newAddresses.map(item => [item.id, item])).values()
                ).sort((a, b) => {
                    const isDefaultA = a?.metadata?.default === true;
                    const isDefaultB = b?.metadata?.default === true;
                    if (isDefaultA && !isDefaultB) return -1;
                    if (!isDefaultA && isDefaultB) return 1;
                    return 0;
                });

                // 상태 업데이트
                setShippingInfos(uniqueAddresses);

                // 선택된 배송지 업데이트
                if (selectedShippingInfoId) {
                    const updatedAddress = uniqueAddresses.find(
                        addr => addr.id === selectedShippingInfoId
                    );
                    if (updatedAddress) {
                        setSelectedShippingInfo(updatedAddress);
                    }
                }
            }
        };
        useEffect(() => {
            if (selectedShippingInfoId) {
                let data = { id: selectedShippingInfoId }
                return
            }
        }, [selectedShippingInfoId]);



        useEffect(() => {

            if (shippingAddress && shippingAddress.length > 0 && selectAddressId && selectAddressId !== null) {
                const address = shippingAddress.find((addr) => addr.id === selectAddressId);

                setSelectAddress(prevState => ({
                    name: address.name || prevState.name,
                    first_name: address.first_name || prevState.first_name,
                    last_name: address.last_name || prevState.last_name,
                    phone: address.phone || prevState.phone,
                    company: address.company || prevState.company,
                    address_1: address.address_1 || prevState.address_1,
                    address_2: address.address_2 || prevState.address_2,
                    city: address.city || prevState.city,
                    country_code: address.country_code || prevState.country_code,
                    province: address.province || prevState.province,
                    postal_code: address.postal_code || prevState.postal_code,
                    name: address.name || prevState.name,
                    message: address.message || prevState.message,
                }));
            }
        }, [shippingAddress, selectAddressId])

        return (
            <ModalBase ref={modal} width={width} height={"fit-content"} withHeader={withHeader} withFooter={withFooter} withCloseButton={withCloseButton} clickOutsideToClose={clickOutsideToClose} title={title} buttonText={buttonText} borderRadius={10} >
                <div className={style.wrap}>
                    <VerticalFlex gap={10}>
                        <FlexChild alignItems={"center"} justifyContent={'center'} minHeight={48} border={"1px solid #dcdee0"} onClick={onAddShippingInfoClick} cursor={"pointer"} margin={"10px 0px 5px 0px"}>
                            <P size={16}> + 배송지 신규입력</P>
                        </FlexChild>
                        {
                            shippingInfos ?
                                shippingInfos.map((shippingInfo, index) =>
                                    <FlexChild height={"initial"} key={shippingInfo.id}>
                                        <VerticalFlex gap={10}>
                                            <FlexChild>
                                                <div className={style.shippingInfoCard} onClick={() => handleCardClick(shippingInfo)}>
                                                    <HorizontalFlex>
                                                        <FlexChild width={50} padding={"0 0 0 20px"}>
                                                            <Radio
                                                                name={"name"}
                                                                value={shippingInfo.id}
                                                                selectedValue={selectedShippingInfoId}
                                                                onChange={(e) => onShippingInfoChange(shippingInfo.id)}
                                                            />
                                                        </FlexChild>
                                                        <FlexChild>
                                                            <VerticalFlex gap = {5}>
                                                                <FlexChild alignItems="flex-start">
                                                                    <P size={16} weight={"bold"}>
                                                                        {shippingInfo.name}
                                                                        {shippingInfo.metadata?.default && (
                                                                            <span style={{
                                                                                display: "inline-flex",
                                                                                padding: "4px 8px",
                                                                                marginLeft: "5px",
                                                                                backgroundColor: "var(--main-color)",
                                                                                color: "white",
                                                                                borderRadius: "4px",
                                                                                fontSize: "14px",
                                                                            }}>
                                                                                기본배송지
                                                                            </span>
                                                                        )}
                                                                    </P>
                                                                </FlexChild>

                                                                <FlexChild alignItems="flex-start">
                                                                    <P>{shippingInfo.address_1}</P>
                                                                </FlexChild>
                                                                <FlexChild alignItems="flex-start">
                                                                    <P>{shippingInfo.address_2}</P>
                                                                </FlexChild>
                                                                <FlexChild alignItems="flex-start">
                                                                    <P>{shippingInfo.phone}</P>
                                                                </FlexChild>
                                                                <FlexChild>
                                                                        <HorizontalFlex justifyContent={"flex-start"} gap={20}>
                                                                            <FlexChild width={"initial"}>
                                                                                <div onClick={(e) => onEditButtonClick(e, shippingInfo)}>
                                                                                    <P size={13} color={"#2E9CC3"} weight={"bold"}>{t("edit")}</P>
                                                                                </div>
                                                                            </FlexChild>
                                                                        </HorizontalFlex>
                                                                </FlexChild>
                                                            </VerticalFlex>
                                                        </FlexChild>
                                                    </HorizontalFlex>
                                                </div>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                )
                                :
                                <VerticalFlex gap={10} padding={"10px 0px"}>
                                    <FlexChild alignItems="flex-start">
                                        <P>{t("noShippingInfo")}</P>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <P size={13} cursor onClick={onAddShippingInfoClick} color={"#2E9CC3"} weight={"bold"}>+ {t("addAddress")}</P>
                                    </FlexChild>
                                </VerticalFlex>
                        }
                    </VerticalFlex>
                </div>
            </ModalBase>
        );
    }
);

export default ShippingInfoSelectModal;